import { Model } from "react3l-common";
import { Field } from "react3l-decorators";

export class EnumModel extends Model {
  @Field(Number)
  public id?: number;
  @Field(String)
  public name?: string;
  @Field(String)
  public code?: string;
}
